package org.catharsis.spendtel.feature.support

import org.catharsis.spendtel.feature.legal.LegalConstants

enum class SupportTopic(val label: String) {
    Billing("Billing & reports"),
    Account("Account & data"),
    Technical("Bug or technical issue"),
    Feature("Feature request"),
    Other("Something else"),
}

data class SupportRequest(
    val name: String,
    val email: String,
    val topic: SupportTopic,
    val message: String,
)

fun buildSupportMailto(request: SupportRequest): String {
    val subject = formUrlEncode("[SpendTel Support] ${request.topic.label}")
    val body = formUrlEncode(
        buildString {
            appendLine("Name: ${request.name.trim()}")
            appendLine("Email: ${request.email.trim()}")
            appendLine("Topic: ${request.topic.label}")
            appendLine()
            append(request.message.trim())
        },
    )
    return "mailto:${LegalConstants.SUPPORT_EMAIL}?subject=$subject&body=$body"
}

private fun formUrlEncode(value: String): String = buildString(value.length) {
    value.forEach { char ->
        when {
            char.isLetterOrDigit() || char in "-_.~" -> append(char)
            char == ' ' -> append("%20")
            else -> {
                char.toString().encodeToByteArray().forEach { byte ->
                    append('%')
                    append(byte.toUByte().toString(16).uppercase().padStart(2, '0'))
                }
            }
        }
    }
}

fun validateSupportRequest(
    name: String,
    email: String,
    message: String,
): String? {
    if (name.trim().isEmpty()) return "Please enter your name."
    if (email.trim().isEmpty()) return "Please enter your email address."
    if (!email.contains('@') || !email.contains('.')) return "Please enter a valid email address."
    if (message.trim().length < 10) return "Please share a few more details so we can help."
    return null
}
